<div class="el-team-wrapper">
    <div class="container">
        <div class="el-team-heading text-center">
            <h4 class="el-top-heading-center">MY PURCHASED PLANS</h4>

        </div>
        <div class="row justify-content-center">
            <div class="col-lg-3 ">

                <a [routerLink]="['/MyMockTest']">
                    <div class="el-blog-box el-blog-box-1 my-3">
                        <div class="el-work-step">
                            <h4>Mock test</h4>
                        </div>
                        <div class="el-blog-img">
                            <img src="../assets/images/all-instructor/my-study-1.png" alt="Team Member">
                            <h4><a [routerLink]="['/MyMockTest']">Attempt</a></h4>
                        </div>
                        <!-- <div class="el-blog-content">

                        <h4>Vocational Counselling</h4>

                    </div> -->
                    </div>
                </a>
            </div>
            <div class="col-lg-3">
                <a [routerLink]="['/book-details']" [queryParams]="{ booktype: 4 }">
                    <div class="el-blog-box el-blog-box-2 my-3">
                        <div class="el-work-step">
                            <h4>eBooks</h4>
                        </div>
                        <div class="el-blog-img">
                            <img src="../assets/images/all-instructor/my-study-2.png" alt="Team Member">
                            <h4><a [routerLink]="['/book-details']" [queryParams]="{ booktype: 4 }">Read book</a></h4>
                        </div>

                    </div>
                </a>
            </div>

            <!-- <div class="col-lg-3">
                <a [routerLink]="['/book-details']" [queryParams]="{ booktype: 1 }">
                    <div class="el-blog-box el-blog-box-3 my-3">
                        <div class="el-work-step">
                            <h4> Books</h4>
                        </div>
                        <div class="el-blog-img">
                            <img src="../assets/images/all-instructor/my-study-3.png" alt="Team Member">
                            <h4><a [routerLink]="['/book-details']" [queryParams]="{  booktype: 1 }">View book</a></h4>
                        </div>

                    </div>
                </a>
            </div> -->

            <div class="col-lg-3">
                <a [routerLink]="['/book-details']" [queryParams]="{ booktype: 3 }">
                    <div class="el-blog-box el-blog-box-4 my-3">
                        <div class="el-work-step">
                            <h4>Pre.Yr.Paper</h4>
                        </div>
                        <div class="el-blog-img">
                            <img src="../assets/images/all-instructor/my-study-4.png" alt="Team Member">
                            <h4><a [routerLink]="['/book-details']" [queryParams]="{ booktype: 3 }">Practice</a></h4>
                        </div>

                    </div>
                </a>
            </div>
        </div>

    </div>
</div>